import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router";
import Button from '../../01_atoms/Button/Button';
import useAPI from '../../../hooks/useAPI';

interface popUpViewDeleteProps {
  title: string;
  auteur: string;
  id: string;
  setShowPopUp: (showPopUp: boolean) => void;
}

function PopUpViewDelete(props: popUpViewDeleteProps) {
  const { title, auteur, id, setShowPopUp } = props;
  const [clicked, setClicked] = useState('');
  const navigate = useNavigate();
  const { Delete } = useAPI();

  const handleClicked = async () => {
    if (clicked === 'Ja') {
      try {
        await Delete(`/admin/books/${id}`);
        setShowPopUp(false);
        // setDataChanged(true);
        const event = new CustomEvent('ShowAlert', {
          detail: {
            label: 'Boek is succesvol verwijderd',
            type: 'Success',
          },
        });
        navigate('../admin');
        globalThis.dispatchEvent(event);
      } catch (error) {
        // Delete failed
        setShowPopUp(false);
        const event = new CustomEvent('ShowAlert', {
          detail: {
            label: 'Boek is niet verwijderd',
            type: 'Warning',
          },
        });
        globalThis.dispatchEvent(event);
      }
    } else {
      // Clicked cancel button
      setShowPopUp(false);
    }
  };

  useEffect(() => {
    if (clicked !== '') {
      handleClicked().catch((error) => {
        globalThis.dispatchEvent(
          new CustomEvent('ShowAlert', {
            detail: {
              label:
                error instanceof Error
                  ? error.message
                  : 'Er is een fout opgetreden bij het verwijderen van het boek',
              type: 'Warning',
            },
          }),
        );
      });
    }
  }, [clicked]);

  return (
    <div className="o-pop-up-modal">
      <div className="o-pop-up-modal__container">
        <p>Weet je zeker dat je boek</p>
        <div className="o-pop-up-modal__text-container">
          <p>{title}</p>
          <p className="o-pop-up-modal__text-author">{auteur}</p>
        </div>
        <p>zult verwijderen uit de bibliotheek</p>
        <div className="o-pop-up-modal__buttons">
          <Button label="Ja" type="primary" setClicked={setClicked} />
          <Button label="Nee" type="secondary" setClicked={setClicked} />
        </div>
      </div>
    </div>
  );
}

export default PopUpViewDelete;

